
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySphericalWest as ObiBuoySphericalWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spherical-west.js';
 
 
 

 
 export const ObiBuoySphericalWest = createComponent({
   react: React,
   tagName: 'obi-buoy-spherical-west',
   elementClass: ObiBuoySphericalWestElement,
   events: {
     
   }
  });
 
 